module.exports = __webpack_public_path__ + "img/yourstory-axtria-funding.e8db41a4.png";